import $ from "jquery";

$(document).ready( ()=> {
    $('.footer__link').on('click', function (e) {
        e.preventDefault();
        $('.footer__pop-up-v-chat').fadeIn(300);
    })

    $('.footer__pop-up-close').on('click', function () {
        $('.footer__pop-up-v-chat').fadeOut(300);
    })

    $( document ).on( 'keydown', function ( e ) {
        if ( e.keyCode === 27 ) {
            $('.footer__pop-up-v-chat').fadeOut(300);
        }
    });
})